export default __webpack_public_path__ + "static/media/flag-spain.f469a717.svg";